<template>
  <div class="d-flex align-items-center justify-content-between">
    <b-form-group class="mr-3 mb-0 flex-grow-1">
      <b-form-input v-model="listFilters.keyword" id="input-search-punch-card-keyword"
        placeholder="Campaign Name"></b-form-input>
    </b-form-group>
    <b-button variant="primary" id="button-search-punch-card-list" class="btn-pill flex-shrink-0 px-4"
      :disabled="!listFilters.keyword" @click="doSearch">Search</b-button>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields("punchCard", ["listFilters"])
  },
  data() {
    return {
      storedKeyword: null
    }
  },
  methods: {
    doSearch() {
      this.storedKeyword = this.listFilters.keyword;

      this.$root.$emit("doSeachPunchCardCampaign");
    }
  },
  watch: {
    "listFilters.keyword"(value) {
      if (!value && this.storedKeyword) this.doSearch();
    }
  }
}
</script>

<style lang="scss" scoped>
input,
button {
  height: 48px;
}

#input-search-punch-card-keyword {
  background: transparent url("~@/assets/images/search-2.svg") no-repeat left 12px center;
  background-size: 21px;
  padding-left: 2.75rem;
  border-radius: 10px;
  
  &.btn-disabled {
    color: #fff;
  }

  &::placeholder {
    color: #C2C8CC;
    font-size: 16px;
  }
}
</style>
